module.exports = __webpack_public_path__ + "img/account_circle_blue.3da991fa.svg";